import toast from "react-hot-toast";
import { clientRoutes } from "../routes";
import axiosInstance from "./Axios";

export class AgentApi {
  static DesignationsList = async () => {
    try {
      const res = await axiosInstance.get(`agent/search-designations`);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static CreateAgentProfile = async (data: any) => {
    try {
      const res = await axiosInstance.post(`agent/create-profile`, data);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static createAgencyProfile = async (data: any) => {
    try {
      const res = await axiosInstance.post(
        `agent/register/create-agency-profile`,
        data
      );
      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static GetAgentProfile = async () => {
    try {
      const res = await axiosInstance.get(`agent/agent-details`);

       localStorage.setItem("user", JSON.stringify(res.data));

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      if (status === 401) {
        window.location.href = clientRoutes.login;
        toast.error("Unauthorized, please login!");
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static updateAgentProfile = async (data: any, agent_id: string) => {
    try {
      const res = await axiosInstance.put(
        `client/agents/update/${agent_id}`,
        data
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static updateInviteStatus = async () => {
    try {
      const res = await axiosInstance.post(
        `agent/agency-invitation/invitation-sent`
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static getAgentById = async (params: { id: string }) => {
    try {
      const res = await axiosInstance.get(`agent/agent-details/${params.id}`);

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static getAgentList = async ({
    page,
    search,
    agency_id,
  }: {
    page: number;
    search: string;
    agency_id: string;
  }) => {
    try {
      const res = await axiosInstance.get(`client/agents/`, {
        params: {
          page,
          limit: 20,
          created_at: "desc",
          search,
          agency_id,
        },
      });

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static getJoiningRequestsList = async ({
    page,
    search,
    status,
  }: {
    page: number;
    search: string;
    status: string;
  }) => {
    try {
      const res = await axiosInstance.get(`client/joining-requests`, {
        params: {
          page,
          limit: 20,
          search,
          status,
        },
      });

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static getJoiningRequestById = async (request_id: string) => {
    try {
      const res = await axiosInstance.get(
        `client/joining-requests/${request_id}`
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static getPermissionsById = async (agent_id: string) => {
    try {
      const res = await axiosInstance.get(
        `admin/permissions/agent/${agent_id}`
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static getJoiningRequestCount = async () => {
    try {
      const res = await axiosInstance.get(
        `client/joining-requests/pending/count`
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static joiningRequestsStatus = async (data: any, requests_id: string) => {
    try {
      const res = await axiosInstance.put(
        `client/joining-requests/${requests_id}/status`,
        data
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static updatePermissions = async (data: any, permissions_id: string) => {
    try {
      const res = await axiosInstance.put(
        `admin/permissions/${permissions_id}/update`,
        data
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static getRolesList = async () => {
    try {
      const res = await axiosInstance.get(`admin/roles`, {});

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static registerAgency = async (data: {
    role: string;
    email: string;
    invitation_code: string;
    principal_agent_id: string;
    principal_agent_first_name: string;
    principal_agent_last_name: string;
    principal_agent_mobile_number: string;
    phone_country_code: string;
  }) => {
    try {
      let url = "agent/register/register-agency";

      const res = await axiosInstance.post(url, data);

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static switchUserProfile = async (data: any) => {
    try {
      const res = await axiosInstance.post(`client/switch-user-profile`, data);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };
}
